/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import app from 'flarum/forum/app';
import { slug } from '../../../common';
import LeaderboardListItem from './LeaderboardListItem';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.leaderboard`;
export default class LeaderboardHero extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    return m("div", {
      className: "LeaderboardHero Hero"
    }, m("h1", {
      className: "Hero-title"
    }, t(`${prfx}.title`)), app.leaderboard.activityType && m("div", {
      className: "Hero-subtitle"
    }, m(Icon, {
      name: LeaderboardListItem.getIconMap()[app.leaderboard.activityType]
    }), " ", t(`${prfx}.nav.${app.leaderboard.activityType}`)));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/leaderboards/components/LeaderboardHero', LeaderboardHero);